import { Range } from '@shopify/polaris';
import { SendInstallationDataRequestPayload, SendInstallationDataV2RequestPayload } from '../../requests';
import { StoreType } from '../Settings/components/types';
import type { BackfillScope } from './constants';

export interface FormValues {
  iterableKey: string;
  email: string;
  timeFrom?: Range;
  scopes: (BackfillScope | 'hidden')[];
  storeType: StoreType;
}

export const getRequestPayload = (formValues: FormValues): SendInstallationDataRequestPayload => {
  const {
    iterableKey,
    email,
    timeFrom,
    scopes,
    storeType,
  } = formValues;

  return {
    iterableKey,
    email,
    historyBackfill: { // TODO: consider use fieldset with historyBackfill name instead
      timeFrom: timeFrom?.start?.toISOString(), // TODO: change format
      scopes: scopes.filter((value): value is BackfillScope => value !== 'hidden'),
    },
    storeType,
  };
};

export const convertToV2Payload = (
  payload: SendInstallationDataRequestPayload
): SendInstallationDataV2RequestPayload => {
  return {
    iterable_api_key: payload.iterableKey,
    email: payload.email,
    store_type: payload.storeType,
    history_backfill: {
      time_from: payload.historyBackfill.timeFrom,
      scopes: payload.historyBackfill.scopes,
    },
  };
};
